const BurundiSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111056)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M32.1779 4.13239C25.0176 -1.37745 14.9826 -1.37745 7.82227 4.13231L20.0001 16.3101L32.1779 4.13239Z"
        fill="#D80027"
      />
      <path
        d="M19.9999 23.6896L7.82227 35.8673C14.9826 41.3771 25.0176 41.3771 32.1779 35.8673L20.0001 23.6895L19.9999 23.6896Z"
        fill="#D80027"
      />
      <path
        d="M16.3111 19.9991L4.13336 7.82129C-1.37648 14.9816 -1.37648 25.0166 4.13336 32.1769L16.3111 19.9991Z"
        fill="#6DA544"
      />
      <path
        d="M23.6895 19.9991L35.8671 32.1769C41.377 25.0166 41.377 14.9816 35.8671 7.82129L23.6895 19.9991Z"
        fill="#6DA544"
      />
      <path
        d="M19.9998 28.6959C24.8023 28.6959 28.6954 24.8028 28.6954 20.0003C28.6954 15.1979 24.8023 11.3047 19.9998 11.3047C15.1974 11.3047 11.3042 15.1979 11.3042 20.0003C11.3042 24.8028 15.1974 28.6959 19.9998 28.6959Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9999 13.9131L20.7529 15.2175H22.2591L21.506 16.5218L22.2591 17.8261H20.7529L19.9999 19.1305L19.2468 17.8261H17.7407L18.4938 16.5218L17.7407 15.2175H19.2468L19.9999 13.9131Z"
        fill="#D80027"
      />
      <path
        d="M16.1728 20L16.9258 21.3044H18.4319L17.6789 22.6087L18.4319 23.913H16.9258L16.1728 25.2174L15.4197 23.913H13.9136L14.6666 22.6087L13.9136 21.3044H15.4197L16.1728 20Z"
        fill="#D80027"
      />
      <path
        d="M23.8281 20L24.5811 21.3044H26.0872L25.3342 22.6087L26.0872 23.913H24.5811L23.8281 25.2174L23.0749 23.913H21.5688L22.3219 22.6087L21.5688 21.3044H23.0749L23.8281 20Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111056">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BurundiSvg;
